import Cookies from 'js-cookie'

export const prepareHeaders = (headers: Headers) => {
  const token = Cookies.get('token')

  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  return headers
}
